import React from 'react';
import { Box, Typography } from '@mui/joy';

/**
 * Reusable component for ICD-10-GM attribution notice
 * To be displayed in all places where the ICD database is used
 */
const IcdAttribution = () => {
  return (
    <Box sx={{ 
      mt: 3, 
      pt: 2, 
      borderTop: '1px solid', 
      borderColor: 'divider',
      backgroundColor: 'background.level1', 
      p: 2, 
      borderRadius: 'sm'
    }}>
      <Typography level="body-sm" sx={{ 
        color: 'text.secondary',
        fontStyle: 'italic',
        display: 'block',
        textAlign: 'center'
      }}>
        Dieses Tool nutzt die maschinenlesbare Fassung der ICD-10-GM 
        des Bundesinstituts für Arzneimittel und Medizinprodukte (BfArM).
        Die Erstellung erfolgt unter Verwendung der maschinenlesbaren
        Fassung des BfArM. Quelle: <a href="https://www.bfarm.de" target="_blank" rel="noopener noreferrer">https://www.bfarm.de</a>
      </Typography>
    </Box>
  );
};

export default IcdAttribution;
